import React from 'react';


const GoalSVG = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 12L19 5" stroke="#F3A60D" strokeLinecap="round"/>
      <path d="M16 8V4L19 1V5H23L20 8H16Z" stroke="#F3A60D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.1568 9.46055C21.3805 10.2689 21.5 11.1205 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C12.8795 2.5 13.7311 2.61952 14.5394 2.8432L15.3402 2.04244C14.2909 1.69062 13.1677 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 10.8323 22.3094 9.70906 21.9576 8.65979L21.1568 9.46055Z" fill="#F3A60D"/>
      <path d="M13.4901 7.75256C13.0237 7.58896 12.5222 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 11.5172 16.424 11.0522 16.2832 10.6162L15.456 11.4435C15.485 11.6247 15.5 11.8106 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C12.2317 8.5 12.4581 8.52251 12.6772 8.56546L13.4901 7.75256Z" fill="#F3A60D"/>
    </svg>

  );
};

export default GoalSVG;
